export const writeToClipboard = async (text) => {
  if (!window.navigator.clipboard) {
    // Clipboard API not available
    return;
  }
  try {
    await window.navigator.clipboard.writeText(text);
  } catch (err) {
    // console.error('Failed to copy!', err);
  }
};

export const isImage = (url) => (/\.(jpeg|jpg|png|gif)/g).test(url);
